// Some locations we know about.
// All values in degrees.
export default {
  atca: {
    name: "ATCA",
    latitude: -30.3128846,
    longitude: 149.5501388,
    elevationLimit: 12.0
  },
  parkes: {
    name: "Parkes 64m",
    latitude: -32.9984064,
    longitude: 148.2635101,
    elevationLimit: 30.0
  },
  mopra: {
    name: "Mopra 22m",
    latitude: -31.2678132,
    longitude: 149.0996405,
    elevationLimit: 12.0
  },
  askap: {
    name: "ASKAP",
    latitude: -26.694442,
    longitude: 116.630464,
    elevationLimit: 15.0
  }
};
